import type { Template } from "@/types";

export const PO_02_H0_V2: Template[] = [

    {
        id: "po-02-h0v2-01",
        name: "PO 01 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_01.png",
        size: [1271, 847],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 636, height: 847, rotation: 0, imageRotation: 0 },
            { id: "2", x: 709, y: 84, width: 488, height: 685, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-02-h0v2-02",
        name: "PO 02 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_02.png",
        size: [1271, 847],
        style: {},
        slots: [
            { id: "1", x: 74, y: 84, width: 488, height: 685, rotation: 0, imageRotation: 0 },
            { id: "2", x: 636, y: 0, width: 636, height: 847, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-02-h0v2-03",
        name: "PO 03 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 783, y: 87, width: 494, height: 742, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 87, width: 494, height: 742, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-04",
        name: "PO 04 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 252, y: 136, width: 429, height: 645, rotation: 0, imageRotation: 0 },
            { id: "2", x: 693, y: 136, width: 429, height: 645, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-05",
        name: "PO 05 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 38, y: 0, width: 609, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 726, y: 0, width: 609, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-06",
        name: "PO 06 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 38, y: 0, width: 609, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 848, y: 183, width: 365, height: 549, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-07",
        name: "PO 07 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 82, y: 65, width: 522, height: 786, rotation: 0, imageRotation: 0 },
            { id: "2", x: 848, y: 183, width: 365, height: 549, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-08",
        name: "PO 08 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 129, y: 136, width: 429, height: 645, rotation: 0, imageRotation: 0 },
            { id: "2", x: 816, y: 136, width: 429, height: 645, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-09",
        name: "PO 09 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 727, y: 0, width: 609, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 161, y: 183, width: 365, height: 549, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-10",
        name: "PO 10 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_10.png",
        size: [1374, 916],
        style: {},
        slots: [
              { id: "1", x: 770, y: 65, width: 522, height: 786, rotation: 0, imageRotation: 0 },
              { id: "2", x: 161, y: 183, width: 365, height: 549, rotation: 0, imageRotation: 0 }
            ],
    },

    {
        id: "po-02-h0v2-11",
        name: "PO 11 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_11.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 111, y: 108, width: 466, height: 700, rotation: 0, imageRotation: 0 },
            { id: "2", x: 798, y: 108, width: 466, height: 700, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-12",
        name: "PO 12 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_12.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 38, y: 36, width: 610, height: 845, rotation: 0, imageRotation: 0 },
            { id: "2", x: 725, y: 36, width: 610, height: 845, rotation: 0, imageRotation: 0 }
        ],
    },

 
];

